import { KeyRounded } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Map from "../components/Map";

const Main = () => {
  const navgiate = useNavigate();
  return (
    <Container>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" gutterBottom>
            Rousen Open API for all developers
          </Typography>
          <Typography variant="body1">Start Building your own client</Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            startIcon={<KeyRounded />}
            onClick={() => navgiate("/clients")}
          >
            Get Api Key
          </Button>
        </Box>
        <Card>
          <CardContent>
            <Map />
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
};

export default Main;
